<script setup lang="ts"></script>
<template>
  <div class="inline-alert">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0003 16.5V10.5M12 7.3335V7.34714M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="var(--infopanel-icon)" stroke-width="1.5" stroke-linecap="round" />
    </svg>
    <div class="text">
      <slot />
    </div>
  </div>
</template>
<style scoped>
.inline-alert {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 12px;
  border-radius: 4px;
  background-color: var(--infopanel-background);
}

svg {
  flex-shrink: 0;
  margin-right: 8px;
}

.text {
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  width: 100%;
  color: var(--infopanel-text);
}
</style>
